import { React, useEffect, useState } from 'react';
import { Grommet, Grid, Header, Card, CardHeader, Tabs, Anchor, CardBody, Box, Text, Button, Page, PageContent, PageHeaders, Tab, Heading } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import ReleaseSummary from '../custom-page/ReadMoreReadLess.js';
import QuickLinksTab from '../custom-page/QuickLinks.js';
import CATab from '../custom-page/CA.js';
import parse from 'html-react-parser';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import PatchComponent from '../patch-page/PatchComponent.js';
import LicenseAgreementComponent from '../licenseagreement-page/LicenseAgreementComponent.js';
//import '../../i18n';

import { useTranslation } from 'react-i18next';



// import i18n from '../../i18n';

// import ReactDOM from 'react-dom';
// // import App from '../../App';
// import { I18nextProvider, useTranslation } from 'react-i18next';

// // import styled from 'styled-components';

// ReactDOM.render(
//   <I18nextProvider i18n={i18n}>
//     <App />
//   </I18nextProvider>,
//   document.getElementById('root')
// );

function convertHtmlToText(html) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  const anchors = tempDiv.getElementsByTagName('a');
  for (let anchor of anchors) {
    const text = anchor.textContent;
    const href = anchor.href;
    const color = anchor.style.color || '#01A982';
    const replacement = `${text} (Link: ${href}, Color: ${color})`;
    anchor.replaceWith(document.createTextNode(replacement));
  }

  const textContent = tempDiv.innerText || tempDiv.textContent;
  return textContent.trim();
}
// Function to update both patchVersion and patchFlag
const handleOSClick = (link) => {

  window.open(link, "_blank");
};



const SPPComponent = ({ }) => {
  const navigate = useNavigate();
 const { t } = useTranslation();  
   const sppTitle = t('SPPOverview');

  console.log(sppTitle);
  // const { version: versionParam } = useParams();


  // useEffect(() => {
  //   if (versionParam && versionParam !== version) {
  //     console.log('Version from URL:', versionParam);
  //   }
  // }, [versionParam, version]);

  const location = useLocation(); // Get the current location (URL)

  // Function to extract query parameters
  const getQueryParams = (param) => {
    const searchParams = new URLSearchParams(location.search); // Parse the query string
    return searchParams.get(param); // Return the value of the passed parameter (e.g., 'version')
  };

  let version = getQueryParams('version'); // Get the 'version' parameter from the URL
  
  if (!version)
    version = 'gen12.2026.01.00.00';

  console.log('versionpassed', version);
  //console.log('patchflagspp', patchComponentFlag);
  const [showLicense, setShowLicense] = useState(false);

  const [sppInfo, setData] = useState(null);
  const [sppType, setType] = useState(null);
  //const [patchVersion, setPatchVersion] = useState(null);
  //const [patchChildFlag, setPatchFlag] = useState(false);
  const [ResolvedCAData, setResolvedCA] = useState(null);
  const [OpenCAData, setOpenCA] = useState(null);
  const [QuickLinks, setQuickLinks] = useState(null);
  const [patchType, setpatchType] = useState(null);
  const sppVersion = version;// "gen11" + ".2024.04.00.00";
  //const fileName = './assets/' + sppVersion + '.json';
  const basePath = window.location.origin;
  const pathName = window.location.pathname;
  // Construct the dynamic path to the config.json file
  let fileName = `${basePath}${pathName}assets/${sppVersion}.json`;

  console.log('sppfilename', fileName);

  //const location = useLocation();

  // useEffect(() => {
  //   // Check on page load if handlePatchClick was called
  //   if (patchChildFlag) {
  //     console.log('handlePatchClick was called on page load');
  //     // Additional logic if needed
  //     setPatchFlag(true);
  //     setShowLicense(false);
  //   }
  //   else {
  //     setPatchFlag(false);
  //   }
  // }, [patchChildFlag]);



  useEffect(() => {
    fetch(fileName)
      .then(response => response.json())
      .then(data => {
        setData(data);
        console.log('shrucheck', data);
        console.log('CAData', data.Advisories.OpendCAs);
        //setOpenCA(data.Advisories.OpendCAs);
        // setResolvedCA(data.Advisories.ResolvedCAs);
        // setQuickLinks(data.QuickLinks);
        //setPatchFlag('N');
        const octetCount = (sppVersion.match(/\./g) || []).length;
        if (octetCount == 4) {
          setType("Base SPP");
          setpatchType("Patch Bundles");
        }
        else {
          setType("Base SPP");
          setpatchType("Hotfix & Supplements");
        }
      })
      .catch(error => console.error('Error fetching json data:', error));
  }, [fileName, version]);



  // // Example: Extracting query parameters
  // const searchParams = new URLSearchParams(location.search);
  // const versionFromQuery = searchParams.get('version');

  // const t = useTranslation();
  // const sppTitle = t('SPPOverview');
  // const sppTitle = "SPP Overview";

  const sppDescription = "This is a description or summary for the card content. It provides a brief overview of the content or purpose of the card. This content can be dynamic and passed as props to the GrommetCard component.";
  // Initialize sppImportantNotes and sppReleaseSummary with default values (empty string)
  let sppImportantNotes = "";
  let sppReleaseSummary = "";


  // Check if sppInfo is not null or undefined
  if (sppInfo) {
    sppImportantNotes = sppInfo.ImportantNotes
      ? parse(sppInfo.ImportantNotes)
      : "Important Notes not available";  // Fallback if ImportantNotes is missing

    sppReleaseSummary = sppInfo.ReleaseNotes
      ? parse(sppInfo.ReleaseNotes)
      : "Release Summary not available";  // Fallback if ReleaseNotes is missing
  }
  //const ImpNotesTitle = "Important Notes";
  const ImpNotesTitle = t('ImportantInformation');
  //const ReleaseTitle = "Release Summary";
  const ReleaseTitle = t('ReleaseSummary');

  

  //const sppType = "Base";
  const sppReleaseDate = "2024-04-19";
  const formattedDate = sppInfo?.BundleDate.Release
    ? new Date(sppInfo.BundleDate.Release).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    : '';


  //setPatchFlag('N');
  const PatchBundles1 = [
    {
      name: "2024.04.00.01",
      link: "/patch/index.aspx"
    },
    {
      name: "2024.04.00.02",
      link: "/patch/index.aspx"
    },
    {
      name: "2024.04.00.03",
      link: "/patch/index.aspx"
    }
  ];

  // Check if patchFlag is 'Y' and render PatchComponent
  // if (patchChildFlag === 'Y') {
  //   return <PatchComponent patchVersion={patchVersion} />;
  // }


  const onLicenseLinkClick = (link) => {

    if (link.includes('/licenseagreements')) {
      navigate(`/#/spp/licenseagreements`);
    }
  };



  // Function to update both patchVersion and patchFlag
  const handlePatchClick = (newVersion) => {
    navigate(`/patch/index.aspx?version=${newVersion}`);
    console.log('called handlepatch', newVersion);
  };



  const offlineUpdateVersions = ["2026.03.00.00","2026.01.00.00", "2025.11.01.00", "2025.09.01.00", "2025.07.00.00", "2025.05.00.00", "2025.03.00.00"];

  const GrommetCard = ({ title, description, sppInfo, patchType, sppType }) => (

    // <Box margin={{ left: 'medium' }}>

    <Card
      width="750px"
      height="450px"
      elevation="medium"
      background="light-1"
      round="small"

    >
      <Header margin={{ left: 'xsmall' }}>
        <Heading weight="bold" level={3}>
          {title}
        </Heading>
      </Header>
      <CardBody pad='None' gap='None' overflow="auto">
        {sppInfo &&
          <>
            <Box margin={{ left: 'xsmall' }} direction="column" gap="small">
              <Box direction="row" gap="small">
                <Box direction="column" gap="small">
                  <Text font-size="medium" weight="bold" >{t('Type')}</Text>
                  <Text font-size="medium">{sppType}</Text>
                </Box>
                <Box direction="column" gap="small">
                  <Text font-size="medium" weight="bold" >{t('ReleaseDate')}</Text>
                  <Text font-size="medium">{formattedDate}</Text>
                </Box>
                <Box direction="column" gap="small">
                  <Text font-size="medium" weight="bold" >{t('PartNumber')}</Text>
                  <Text font-size="medium" >{sppInfo?.PartNumber || 'N/A'}</Text>
                </Box>
                <Box direction="column" gap="small">
                  <Text font-size="medium" weight="bold" >{patchType}</Text>
                  <Text >
                    {sppInfo.PatchBundles.map((bundle, index) => (
                      <Box key={index} direction="row" gap="small">
                        <Text font-size="medium" color="brand">
                          { bundle.Name === '' ? (
                             t('NoPatches')
                           ):
                          patchType === "Patch Bundles"? (
                            <Anchor
                              onClick={() => handlePatchClick(sppInfo.Generation.toLowerCase() + '.' + bundle.Name)}
                              //onClick={handlePatchClick(sppInfo.Generation.toLowerCase() + '.' + bundle.Name)}
                              label={bundle.Name}
                            />

                          ) : (
                            <Anchor target="_blank" rel="noopener noreferrer" href={bundle.link} onClick={() => handleOSClick(bundle.link)} label={bundle.Name} />
                          )}
                        </Text>

                      </Box>
                    ))}
                  </Text>
                </Box>
              </Box>
            </Box>

            <Box margin={{ left: 'xsmall' }} direction="column" gap="small">
              <Box direction="row" gap="small">
                <Box direction="column" gap="small">
                  <Text font-size="medium" weight="bold" >{t('SUMVersion')}</Text>
                  <Text font-size="medium">{sppInfo.SUMVersion}</Text>
                </Box>
                <Box direction="column" gap="small">
                  <Text font-size="medium" weight="bold" >{t('Size')}</Text>
                  <Text font-size="medium">{sppInfo.Size}</Text>
                </Box>
              </Box>
            </Box>

            <Box margin={{ left: 'xsmall' }} direction="column" gap="small">
              <Box direction="row" gap="small">
                <Box direction="column" gap="small">
                  <Text font-size="medium" weight="bold" >{t('UpdateFrom')}</Text>
                  <Text font-size="medium">{sppInfo?.UpdateFromBundleVersion || 'N/A'}</Text>
                </Box>
                <Box direction="column" gap="small">
                  <Button
                    label={t('CreateanSPPCustomDownload')}          
                    onClick={() => window.open(sppInfo?.CustomSPPDownloadLink, '_blank')}
                    secondary
                  />
                </Box>
              </Box>

              <Box direction="column" gap="small">
                <Box direction="row" gap="small">
                  <Button
                    label={t('DownloadBaseSPP')}
                    onClick={() => window.open(sppInfo?.SPPDownloadLink, '_blank')}
                    primary
                  />
                  {sppInfo?.SPPName && sppInfo?.BundleVersion &&
                    `${sppInfo.SPPName} Version ${sppInfo.BundleVersion}` ===
                    "Gen12 Service Pack for ProLiant Version 2024.11.00.00" ? (
                    <Text size="medium" color="brand">
                      <Anchor
                        href="https://downloads.linux.hpe.com/SDR/repo/aip/"
                        //label="SDR AIP Bundle Download"
                        label={t('SIPLink')}

                        target="_blank"
                        rel="noopener noreferrer"
                      />
                    </Text>
                  ) : null}
                  {/* <Text font-size="medium" color="brand">
                      <Anchor href={sppInfo?.License} onClick={()=>onLicenseLinkClick(sppInfo.License)} label="License Agreement" />
                    </Text> */}
                </Box>
              </Box>

              <Box direction="column" gap="small">
<Box direction="row" gap="small">
  {sppInfo?.SPPName === "Service pack for HPE ProLiant Gen12 " &&
    offlineUpdateVersions.includes(sppInfo?.BundleVersion) && (
      <Text size="medium" style={{ fontWeight: 'bold', color: 'black' }}>
        {t('OfflineUpdatemsg')}
      </Text>
  )}
</Box>
              </Box>
            </Box>
          </>}
      </CardBody>
    </Card>
    // </Box>
  );

  //const t = useTranslation();
 // const sppTitle = t('SPPOverview');

 // console.log(sppTitle);

  return (
    <Grommet themeMode="light" theme={hpe}>
      <Box direction='column' gap="small">
        {/* {patchChildFlag === 'Y' ? (
          // //  Render PatchComponent when patchFlag is 'Y'
          <PatchComponent patchVersion={patchVersion} />
        ) : ( */}
        {/* // Render the other components when patchFlag is not 'Y' */}
        {console.log("------------------------rendered")}
        {/* {patchChildFlag ? (
          <PatchComponent patchVersion={patchVersion} />
        ) : ( */}
        {sppInfo && sppInfo.SPPName && (
          <>
            <Box direction="row" gap="small">
              {/* Page Title */}
              {sppInfo.BundleVersion && (
                <Box margin={{ left: 'xsmall', bottom: 'medium' }}>
                  <Header>
                    <Heading weight="bold" level={1}>
                      {`${sppInfo.SPPName} Version ${sppInfo.BundleVersion}`}
                    </Heading>
                  </Header>
                </Box>
              )}
            </Box>

            {/* Render these boxes only if patchFlag is not 'Y' */}
            <Box direction="row" gap="small">
              <Box direction="column" gap="medium">
                <GrommetCard
                  title={sppTitle}
                  description={sppDescription}
                  sppInfo={sppInfo}
                  sppType={sppType}
                  patchType={patchType}
                />
              </Box>
              <Box direction="column" gap="medium">
                <ReleaseSummary text={sppImportantNotes} title={ImpNotesTitle} summaryheight={"450px"}></ReleaseSummary>
              </Box>
              <Box direction="column" gap="medium">
                <ReleaseSummary text={sppReleaseSummary} title={ReleaseTitle} summaryheight={"450px"}></ReleaseSummary>
              </Box>
            </Box>
            <Box direction="row" gap="small" pad="small">

            </Box>

            <Box direction="row" gap="large">
              <Box direction="column" gap="medium">
                <Box alignContent="start" fill="horizontal" direction="row" gap="medium">
                  <Tabs justify="start">
                    <Tab background="light-2" title={t('QuickLinks')}>
                      <QuickLinksTab align="start" QuickLinks={sppInfo.QuickLinks} />
                    </Tab>
                    <Tab background="light-2" title={t('ResolvedCAs')}>
                      <CATab CAdata={sppInfo.Advisories.ResolvedCAs} />
                    </Tab>
                    <Tab background="light-2" title={t('OpenCAs')}>
                      <CATab CAdata={sppInfo.Advisories.OpendCAs} />
                    </Tab>
                  </Tabs>
                </Box>
              </Box>
            </Box>
          </>
        )}

        {/* )}  */}

      </Box>
    </Grommet >

  );

};


SPPComponent.propTypes = {
  version: PropTypes.string,
  //setPatchVersion: PropTypes.func,
  patchFlag: PropTypes.bool,
  patchVersion: PropTypes.string,
  setPatchVersion: PropTypes.func,
  setPatchFlag: PropTypes.func
};
export default SPPComponent;
